import { createContext, ReactNode, useContext, useMemo } from 'react'
import { useSignOutScopedFlag } from 'shared/hooks/use-sign-out-scoped-flag'

const STORAGE_KEY = 'passwordPolicyWarningVisible'

interface PasswordPolicyWarningContextValue {
  visible: boolean
  showPasswordPolicyWarning: () => void
  hidePasswordPolicyWarning: () => void
}

const PasswordPolicyWarningContext =
  createContext<PasswordPolicyWarningContextValue | null>(null)

interface Props {
  children: ReactNode
}

export const PasswordPolicyWarningProvider = ({ children }: Props) => {
  const {
    isSet: visible,
    set: showPasswordPolicyWarning,
    clear: hidePasswordPolicyWarning,
  } = useSignOutScopedFlag(STORAGE_KEY)

  const value = useMemo(
    () => ({
      visible,
      showPasswordPolicyWarning,
      hidePasswordPolicyWarning,
    }),
    [visible, showPasswordPolicyWarning, hidePasswordPolicyWarning]
  )

  return (
    <PasswordPolicyWarningContext.Provider value={value}>
      {children}
    </PasswordPolicyWarningContext.Provider>
  )
}

export const usePasswordPolicyWarning = () => {
  const context = useContext(PasswordPolicyWarningContext)

  if (!context) {
    throw new Error(
      'usePasswordPolicyWarning must be used inside PasswordPolicyWarningProvider'
    )
  }

  return context
}
